import { all, takeEvery, put } from 'redux-saga/effects';
import actions from './actions';
import siteConfig from '@iso/config/site.config';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
  baseURL: siteConfig.siteUrl.API_URL,
}
const headers = {
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
}

export function* getUsersSaga() {
  let ULRDestino = "api/users/";
  const res = yield gaxios.request({
    url: ULRDestino,
    headers: headers,
  });
  if(res.data.success){
    yield put({
      type: actions.ADD_USERS,
      users: res.data.users,
    });
    if (res.data.paginationInfo){
      yield put({
        type: actions.SET_PAGINATION_INFO,
        payload: res.data.paginationInfo,
      });
    }
  }else{
    
  }
}

export function* importUsers( action ) {
  let ULRDestino = "api/upload/importUsers/";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: "POST",
    data: action.data,
    headers: headers,
  });
  if(res.data.success){
    notification('success', res.data.msg )
    yield put({
      type: actions.GET_USERS,
    });
  }else{
    console.log(res)
  }
}

export function* editUser(action) {
  let ULRDestino = "api/users/"+action.id;
  const data = action.data;
  const res = yield gaxios.request({
    url: ULRDestino,
    method: "PUT",
    data,
    headers: headers
  });
  if(res.data.success){
    notification('success', res.data.msg )
    yield put({ 
      type: actions.GET_USERS,
    });
  }else{
    notification('error', res.data.msg )
  }
}

export function* deleteUser(action) {
  let ULRDestino = "api/users/"+action.id;
  const data = action.userData;
  const res = yield gaxios.request({
    url: ULRDestino,
    method: "DELETE",
    data,
    headers: headers
  });
  if(res.data.success){
    notification('success', res.data.msg )
    yield put({ 
      type: actions.GET_USERS,
    });
  }else{
    notification('error', res.data.msg )
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_USERS, getUsersSaga),
    yield takeEvery(actions.EDIT_USER, editUser),
    yield takeEvery(actions.DELETE_USER, deleteUser),
    yield takeEvery(actions.IMPORT_USERS, importUsers),
  ]);
}
